import {
    combineReducers,
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import LogRocket from 'logrocket';
import hasCookieCategoryConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import trackPage from '%app/js/common/redux/googleAnalytics/middleware/trackPage';
import batchThunk from '%app/js/common/redux/batchThunk/middleware/batchThunk';
import seatSelectionIntegrationReducer from '%paysera_seat_selection_integration/js/seatings/redux/components';
import currentEventReducer from '%evp_ticket_frontend/js/redux/currentEvent/reducers';
import currentCartReducer from '%evp_ticket_frontend/js/redux/currentCart/reducers';
import currentOrderReducer from '%evp_ticket_frontend/js/redux/currentOrder';
import snackbarReducers from '%app/js/common/components/material/Snackbar/redux/reducers';
import { ENVIRONMENT } from './constants';
import history from './history';
import filterBuyerLogRocket from './service/filterBuyerLogRocket';

const createRootReducer = historyDefinition => (combineReducers({
    form: formReducer,
    router: connectRouter(historyDefinition),
    seat_selection: seatSelectionIntegrationReducer,
    current_event: currentEventReducer,
    current_cart: currentCartReducer,
    current_order: currentOrderReducer,
    snackbar: snackbarReducers,
}));

const middlewares = hasCookieCategoryConsent(CATEGORY_STATISTICS)
    ? [
        applyMiddleware(
            batchThunk,
            routerMiddleware(history),
            trackPage,
            LogRocket.reduxMiddleware({ ...filterBuyerLogRocket() }),
        ),
    ] : [
        applyMiddleware(
            batchThunk,
            routerMiddleware(history),
        ),
    ];
if (ENVIRONMENT === 'dev' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

const store = createStore(
    createRootReducer(history),
    compose(...middlewares),
);

export default store;
